import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Version } from 'types';

const releaseVersion = async (versionId: string): Promise<Version> => {
  const response = await customAxios.post<Version>(`/versions/${versionId}/release`);
  return response.data;
};

export const useReleaseVersion = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: releaseVersion,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['versions', orgId] }).catch(() => undefined);
    },
  });
};
